import type {
  EnhancedDesignType,
  PosterGenericInput,
  TemplateState,
} from '../../../../store/types/template';
import { mapApiResponseToTemplateState } from './mapApiResponseToTemplateState';

export type PosterTemplateAttributes = {
  id?: string;
  uuid?: string;
  templateType?: string;
  fields?: unknown;
  barcode?: unknown;
  images?: unknown;
  appleEnhancedDesign?: {
    type?: EnhancedDesignType | null;
    images?: { artwork?: string | null; secondaryLogo?: string | null };
    artworkBrightness?: 'light' | 'dark' | null;
    featuredActions?: unknown;
  };
};

export const toPosterGenericInput = ({
  id,
  uuid,
  templateType,
  fields,
  barcode,
  images,
  appleEnhancedDesign,
}: PosterTemplateAttributes): PosterGenericInput => {
  const template = mapApiResponseToTemplateState({
    id: uuid ?? id ?? '',
    attributes: { templateType, fields, barcode, images, appleEnhancedDesign },
  } as unknown as Parameters<
    typeof mapApiResponseToTemplateState
  >[0]) as TemplateState;
  const design = template.appleEnhancedDesign;

  return {
    templateType: template.templateType,
    fields: template.fields,
    images: design.images,
    artworkBrightness: design.artworkBrightness,
    featuredActions: design.featuredActions,
    barcode: template.barcode,
    logo: template.images.apple.logo || template.images.shared.logo,
  };
};
